import { createElement, forwardRef } from 'react';
import * as React from 'react';
import {
	KeyboardAvoidingView as NativeKeyboardAvoidingView,
	KeyboardAvoidingViewProps,
	Platform,
} from 'react-native';

/**
 * https://github.com/APSL/react-native-keyboard-aware-scroll-view
 */
export const KeyboardAvoidingView = forwardRef<
	NativeKeyboardAvoidingView,
	KeyboardAvoidingViewProps
>((props, ref): React.ReactElement => {
	const defaultProps: KeyboardAvoidingViewProps = {
		style: { flex: 1 },
		behavior: Platform.OS === 'ios' ? 'padding' : undefined,
		keyboardVerticalOffset: 75,
	};

	return createElement(NativeKeyboardAvoidingView, {
		...defaultProps,
		...props,
		ref,
	});
});
